import { useEffect } from 'react';
import { useLocation } from 'react-router';

const PractitionerPortalPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${window.location.pathname}${window.location.search}`;
    window.practitionerPortalPageView?.(path, document.title);
  }, [location.pathname, location.search]);

  return null;
};

export default PractitionerPortalPageView;
